import React from 'react'
import styles from './UIGamePlayerInfoSectionContent.module.scss'
import {CardStateUnordered} from '@colonist/game-states'
import {UIGameCardInventory} from '../../../../../common/UIGameCardInventory/UIGameCardInventory'
import IconUsedDevs from '@static/images/icon_used_devs.svg'
import {T} from '@colonist/ui'
import {CARD_STACK_SIZES_1} from '../CardStateUnorderedStackSize1'

export interface UIGamePlayerInfoSectionContentUsedDevsProps {
    cardState: CardStateUnordered
}

export const UIGamePlayerInfoSectionContentUsedDevs = ({
    cardState,
}: UIGamePlayerInfoSectionContentUsedDevsProps) => {
    const isCardStateEmpty = Object.values(cardState).every((value) => value === 0)
    if(isCardStateEmpty) {
        return (
            <div className={styles.container}>
                <img src={IconUsedDevs} className={styles.usedDevsEmptyIcon} />
                <div className={styles.usedDevsEmptyText}><T id="strings:game.playerInformation.usedDevsEmpty" /></div>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <UIGameCardInventory
                className={styles.usedDevsContainer}
                cardState={cardState}
                cardStackSizes={CARD_STACK_SIZES_1}
                cardsToGreyOut={cardState}
                cardSize='xxs'
                forceShowCardBadges={true}
            />
        </div>
    )
}
